<template>
  <ul v-show="visible" class="login-dropdown" :aria-hidden="!visible">
    <li>
      <h3 class="login-dropdown-title">I'm a...</h3>
    </li>
    <li>
      <a :href="parentSignupUrl" class="nav-primary-button nav-outline-button">Parent</a>
    </li>
    <li>
      <a :href="sitterSignupUrl" class="nav-primary-button nav-outline-button">Sitter</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PublicLoginDropdown',
  props: {
    visible: { type: Boolean, required: true },
    returnPath: { type: String, required: true },
  },
  computed: {
    parentSignupUrl() {
      return `/registration?member_type=seeker&return_path=${encodeURIComponent(this.returnPath)}`;
    },
    sitterSignupUrl() {
      return `/sitter/account?return_path=${encodeURIComponent(this.returnPath)}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.login-dropdown {
  position: fixed;
  z-index: 101;
}
</style>
